import { render, staticRenderFns } from "./RelatedProductCarousel.vue?vue&type=template&id=2482a75b&scoped=true"
import script from "./RelatedProductCarousel.vue?vue&type=script&lang=js"
export * from "./RelatedProductCarousel.vue?vue&type=script&lang=js"
import style0 from "./RelatedProductCarousel.vue?vue&type=style&index=0&id=2482a75b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2482a75b",
  null
  
)

export default component.exports